<template>
  <div class="row">
    <div class="col col-12">
      <input class="form-control" :value="valueMutable" readonly>
    </div>
    <div class="col-md-2 mt-1">
      <div class="btn-group">
        <button
          class="btn btn-outline-secondary"
          v-b-tooltip="'Abrir editor'"
          @click="openEditor"
          v-if="hasPermisionSave"
        >
          <span class="material-icons">edit</span>
        </button>
      </div>
    </div>
    <b-modal
      id="modaleditar"
      ref="modaleditar"
      title="Editor online"
      size="xl"
      hide-footer
    >
      <b-spinner
        v-if="loadContent"
        variant="primary"
        size="18"
      />
      <b-card-text v-if="!loadContent">
        <div class="preview">
          <div class="row">
            <div class="col-12 col-md-12">
              <CodeEditor v-model="valueMutable" v-on:input="input">
              </CodeEditor>
            </div>
          </div>
        </div>
      </b-card-text>
      <vs-progress
        v-if="progress.enabled"
        :percent="progress.percent"
        :indeterminate="progress.indeterminate"
        :color="color"
      />
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import CodeEditor from '@/febos/global/empresas/componentes/configs/inputs/CodeEditor';
import InputConfigMixin from '@/febos/global/empresas/componentes/configs/inputs/InputConfigMixin';

export default {
  name: 'ConfigInputTextLarge',
  mixins: [InputConfigMixin],
  components: {
    CodeEditor
  },
  data: () => ({
    loadContent: false,
    viewHtml: false,
    valueMutable: '',
    progress: {
      enabled: false,
      percent: 0,
      indeterminate: true
    }
  }),
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
  },
  mounted() {
    this.valueMutable = this.value;
  },
  methods: {
    input(value) {
      this.$emit('input', value);
    },
    async openEditor() {
      this.$refs.modaleditar.show();
    }
  },
  props: {
    value: {
      type: String,
      required: false,
    },
    param: {
      type: String,
      required: false,
    },
    level: {
      type: String,
      required: false,
    }
  }
};
</script>
<style scoped>

.preview {
  background: #d3d3d30f;
  padding: 10px;
  border-radius: 10px;
  width: 100%;
  color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
}
</style>
